











































































































import Vue from "@/shared/node_modules/vue";
import Component from "@/shared/node_modules/vue-class-component";
import { CrudService } from "@/shared/core/services/crudService";
import { Settings } from "@/shared/core/services/configService";
import store from "@/shared/core/store";
import Popup from "@/shared/components/popup/popup.vue";
import CzButton from "@/shared/components/cz/CzButton.vue";
import CzChip from "@/shared/components/cz/CzChip.vue";
import CzLink from "@/shared/components/cz/CzLink.vue";
import CzNotice from "@/shared/components/cz/CzNotice.vue";
import CzStatus from "@/shared/components/cz/CzStatus.vue";
import CzTitle from "@/shared/components/cz/CzTitle.vue";
import PdfViewer from "@/shared/components/pdfViewer/pdfViewer.vue";

@Component({ components: { Popup, CzButton, CzChip, CzLink, CzNotice, CzStatus, CzTitle, PdfViewer } })
export default class SignDocumentsPage extends Vue {
  loading: boolean = true;
  signing: boolean = false;
  expired: boolean = false;
  signError: string = "";
  docs: any[] = [];
  currentIndex: number = 0;
  allSigned: boolean = false;
  showSignedPopup: boolean = false;
  justSignedDocs: any[] = [];
  sentEmailDocIds: Set<number> = new Set();
  sendingEmailDocId: number | null = null;

  // canvas state
  isDrawing: boolean = false;
  hasSigned: boolean = false;
  lastX: number = 0;
  lastY: number = 0;

  get currentDoc(): any {
    return this.docs[this.currentIndex] || {};
  }

  get currentPdfUrl(): string {
    const fileName = this.currentDoc.fileName;
    if (!fileName) return "";
    if (this.currentDoc.privateFile) {
      return this.signingToken
        ? `${Settings.HostName}/api/customer-signed-docs/to-sign/${encodeURIComponent(this.signingToken)}/${this.currentDoc.id}`
        : `${Settings.HostName}/api/customer-signed-docs/${this.currentDoc.id}/download`;
    }
    const uploads = (store.state as any).settings && (store.state as any).settings.Uploads
      ? (store.state as any).settings.Uploads
      : `${Settings.HostName}/public/uploads`;
    return `${uploads}/${fileName}`;
  }

  get signingToken(): string {
    return (this.$route.query.token as string) || "";
  }

  async created() {
    await this.loadDocs();
  }

  mounted() {
    this.initCanvas();
  }

  async loadDocs() {
    this.loading = true;
    this.expired = false;
    const token = (this.$route.query.token as string) || "";
    const url = `${Settings.HostName}/api/publiccustomersigneddocs/to-sign${token ? "?token=" + encodeURIComponent(token) : ""}`;
    const data = await new CrudService().httpGet(url);

    if (data && (data.status === "expired" || data.status === "notfound")) {
      this.expired = true;
      this.docs = [];
    } else {
      const docs = data && Array.isArray(data.docs) ? data.docs : [];
      this.docs = docs.filter((d: any) => d.status !== 2);
    }

    this.loading = false;
    this.$nextTick(() => this.initCanvas());
  }

  initCanvas() {
    const canvas = this.$refs.sigCanvas as HTMLCanvasElement;
    if (!canvas) return;
    canvas.width = canvas.offsetWidth || 500;
    canvas.height = canvas.offsetHeight || 160;
    const ctx = canvas.getContext("2d")!;
    ctx.strokeStyle = "#111";
    ctx.lineWidth = 2;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
  }

  clearCanvas() {
    const canvas = this.$refs.sigCanvas as HTMLCanvasElement;
    if (!canvas) return;
    canvas.getContext("2d")!.clearRect(0, 0, canvas.width, canvas.height);
    this.hasSigned = false;
  }

  private pos(e: MouseEvent | Touch, canvas: HTMLCanvasElement) {
    const rect = canvas.getBoundingClientRect();
    return {
      x: (e.clientX - rect.left) * (canvas.width / rect.width),
      y: (e.clientY - rect.top) * (canvas.height / rect.height),
    };
  }

  startDraw(e: MouseEvent) {
    this.isDrawing = true;
    const canvas = this.$refs.sigCanvas as HTMLCanvasElement;
    const { x, y } = this.pos(e, canvas);
    this.lastX = x;
    this.lastY = y;
  }

  draw(e: MouseEvent) {
    if (!this.isDrawing) return;
    const canvas = this.$refs.sigCanvas as HTMLCanvasElement;
    const ctx = canvas.getContext("2d")!;
    const { x, y } = this.pos(e, canvas);
    ctx.beginPath();
    ctx.moveTo(this.lastX, this.lastY);
    ctx.lineTo(x, y);
    ctx.stroke();
    this.lastX = x;
    this.lastY = y;
    this.hasSigned = true;
  }

  stopDraw() {
    this.isDrawing = false;
  }

  startDrawTouch(e: TouchEvent) {
    const canvas = this.$refs.sigCanvas as HTMLCanvasElement;
    const { x, y } = this.pos(e.touches[0], canvas);
    this.isDrawing = true;
    this.lastX = x;
    this.lastY = y;
  }

  drawTouch(e: TouchEvent) {
    if (!this.isDrawing) return;
    const canvas = this.$refs.sigCanvas as HTMLCanvasElement;
    const ctx = canvas.getContext("2d")!;
    const { x, y } = this.pos(e.touches[0], canvas);
    ctx.beginPath();
    ctx.moveTo(this.lastX, this.lastY);
    ctx.lineTo(x, y);
    ctx.stroke();
    this.lastX = x;
    this.lastY = y;
    this.hasSigned = true;
  }

  async sendSignedDocumentEmail(doc: any) {
    if (this.sendingEmailDocId || this.sentEmailDocIds.has(doc.id)) return;
    this.sendingEmailDocId = doc.id;
    try {
      await new CrudService().httpPost(
        `${Settings.HostName}/api/publiccustomersigneddocs/send-signed-document-email`,
        { signingToken: this.signingToken, customerSignedDocumentId: doc.id }
      );
      this.sentEmailDocIds = new Set([...this.sentEmailDocIds, doc.id]);
    } finally {
      this.sendingEmailDocId = null;
    }
  }

  trimmedCanvasDataUrl(canvas: HTMLCanvasElement): string {
    const ctx = canvas.getContext("2d")!;
    const { width, height } = canvas;
    const pixels = ctx.getImageData(0, 0, width, height).data;
    let top = height, bottom = 0, left = width, right = 0;
    for (let y = 0; y < height; y++) {
      for (let x = 0; x < width; x++) {
        const alpha = pixels[(y * width + x) * 4 + 3];
        if (alpha > 0) {
          if (y < top) top = y;
          if (y > bottom) bottom = y;
          if (x < left) left = x;
          if (x > right) right = x;
        }
      }
    }
    if (top > bottom || left > right) return canvas.toDataURL("image/png");
    const pad = 10;
    top = Math.max(0, top - pad);
    bottom = Math.min(height, bottom + pad);
    left = Math.max(0, left - pad);
    right = Math.min(width, right + pad);
    const trimmed = document.createElement("canvas");
    trimmed.width = right - left;
    trimmed.height = bottom - top;
    trimmed.getContext("2d")!.drawImage(canvas, left, top, trimmed.width, trimmed.height, 0, 0, trimmed.width, trimmed.height);
    return trimmed.toDataURL("image/png");
  }

  onSignTouch() {
    // iOS Safari frequently fails to dispatch the synthetic `click` on the
    // Sign button after the canvas touch-draw gesture (which uses
    // touchstart/touchmove .prevent), so on iPhone the button "did nothing"
    // and no request ever reached the backend. Triggering on touchend makes
    // the tap reliable; `.prevent` suppresses the ghost click and the
    // `signing` guard inside signCurrent prevents a double submit.
    if (this.signing || !this.hasSigned) return;
    this.signCurrent();
  }

  async signCurrent() {
    if (!this.hasSigned || this.signing) return;
    this.signing = true;
    this.signError = "";

    try {
      const canvas = this.$refs.sigCanvas as HTMLCanvasElement;
      const signatureData = this.trimmedCanvasDataUrl(canvas);

      const res = await new CrudService().httpPost(
        `${Settings.HostName}/api/publiccustomersigneddocs/sign`,
        {
          customerSignedDocumentId: this.currentDoc.id,
          signatureData,
          signerName: "",
          signingToken: this.signingToken,
        }
      );

      if (res && res.errorCode === "expired") {
        this.expired = true;
        return;
      }

      if (res && res.errorCode === "sign_order") {
        this.signError = this.$t("Documents must be signed in order").toString();
        this.currentIndex = 0;
        await this.loadDocs();
        return;
      }

      if (res && res.isOk) {
        this.signError = "";
        this.justSignedDocs.push(this.currentDoc);
        if (this.currentIndex < this.docs.length - 1) {
          // Don't auto-advance: show a confirmation popup so the user
          // understands the document was signed before moving to the next one.
          this.showSignedPopup = true;
        } else {
          this.allSigned = true;
        }
        return;
      }

      // Reached here => the request failed or returned an unexpected payload
      // (e.g. a non-OK status that crudService swallowed into undefined).
      // Without this, the button silently re-enabled and "did nothing" on iOS.
      console.error("[signDocuments] unexpected sign response", res);
      this.signError = this.$t("The signature could not be saved, please try again").toString();
    } catch (e) {
      console.error("[signDocuments] sign request failed", e);
      this.signError = this.$t("The signature could not be saved, please try again").toString();
    } finally {
      this.signing = false;
    }
  }

  goToNextDoc() {
    this.showSignedPopup = false;
    if (this.currentIndex < this.docs.length - 1) {
      this.currentIndex++;
      this.clearCanvas();
      this.$nextTick(() => this.initCanvas());
    }
  }
}
